module.exports = __webpack_public_path__ + "static/a3eea463.theBell.gif";